import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { IPageDetails } from '../../data/page-details';
import { NavigationService } from '../../services/navigation.service';
import { IFormComponent } from '../../models/i-form-component';

@Component({
  selector: 'app-button-bar',
  templateUrl: './button-bar.component.html',
  styleUrls: ['./button-bar.component.scss']
})
export class ButtonBarComponent implements OnInit {
  @Input() currentPageIndex: number = 0;
  @Input() currentPageComponent: IFormComponent | null = null;
  // for debugging set validate to false to allow for stepping through forms without validation
  @Input() validate: boolean = true;
  
  @Output() onSave = new EventEmitter<void>();
  @Output() onSubmit = new EventEmitter<void>();
  
  selectedForm: IPageDetails | null = null;
  showSaveButton = true;
  clicked = false;
  redirectUrl: string | null = null;
  formValid: boolean = true;



  constructor(
    public navigationService: NavigationService
  ) { }

  ngOnInit() {
    this.selectedForm = this.navigationService.selectedRoute;
  }

  goToPrev(): void {

    // if we are going back we don't want to show errors
    this.formValid = true;

    const form = document.getElementById('assessmentForm');

    if (form) {
      form.classList.add('form-min-height');
    }

    if (this.currentPageIndex === 0 || !this.selectedForm) {
      this.navigationService.redirectToHome();
    } else {
      this.navigationService.navigateToPage(this.currentPageIndex - 1);
    }
  }

  // Get the next form page or submit the form if its the last page
  goToNext(): void {

    if (this.currentPageComponent) {
      if (!this.currentPageComponent.isFormValid() && this.validate) {
        this.currentPageComponent.markFormAsTouched();
        this.formValid = false;
        return; 
      }
      
      this.formValid = true;

    } else {
      console.warn('No current page component provided for validation');
      return;
    }

    setTimeout(() => {
      if (this.formValid) {
      if (this.selectedForm) {
          this.navigationService.navigateToPage(this.currentPageIndex + 1);
        } else {
          this.navigationService.redirectToHome();
        }
      }
    }, 0);
  }

  isLastPage(): boolean {
    if (this.selectedForm) {
      this.showSaveButton = true;
      return this.currentPageIndex + 1 === this.selectedForm.pages.length;
    }
    this.showSaveButton = true;
    return true;
  }

  saveProgressClick(): void {
    this.onSave.emit();
  }
  
  onSubmitClick(): void {
      
    // if this isn't the last page you can't submit
    if (this.currentPageComponent && this.isLastPage()) {
      if (!this.currentPageComponent.isFormValid() && this.validate) {
        this.currentPageComponent.markFormAsTouched();
        this.formValid = false;
        return; 
      }
      this.formValid = true;
      this.onSubmit.emit();

    } else {
      console.warn('You cannot submit the form until you are on the last page and the form is valid');
      return;
    }

  }


}